













import {
  defineComponent,
  useRoute,
  computed,
  useMeta,
  useFetch,
  useContext,
  onActivated,
} from '@nuxtjs/composition-api'
import {
  provideProductBrand,
  injectProductBrand,
} from '~/composables/product/useProductBrand'
import { provideProductCategory } from '~/composables/product/useProductCategory'
import { useBreadcrumb } from '~/composables/ui/useBreadcrumb'
import { useContent } from '~/composables/useContent'
import { provideProductList } from '~/composables/product/useProductList'
import { useBreadcrumbsSchemaScript } from '~/composables/useSchemaScript'
import { htmlToText } from '~/lib/utilities'

export default defineComponent({
  name: 'PagesBrandLister',

  setup() {
    provideProductList()
    provideProductCategory()
    provideProductBrand()

    const route = useRoute()
    const { article, ensureContent, htmlMeta, setPageMeta } = useContent()
    const { breadcrumbs, setBreadcrumbs } = useBreadcrumb()
    const { breadcrumbsSchemaScript, setBreadcrumbsSchemaScript } =
      useBreadcrumbsSchemaScript()
    const useProductBrandData = injectProductBrand()
    const { brand, initialize } = useProductBrandData
    const { i18n } = useContext()

    const brandUrl = computed(() => route.value.params.pathMatch)
    const brandName = computed(() => brand.value?.name ?? brandUrl.value)

    const doSetBreadcrumbs = () => {
      setBreadcrumbs([
        {
          to: { name: 'brand' },
          label: i18n.t('brand.title') as string,
        },
        {
          label: brandName.value,
        },
      ])
    }

    useFetch(async () => {
      await Promise.all([initialize(brandUrl.value), ensureContent()])

      setPageMeta({
        title: article.value?.title ?? brandName.value,
        description:
          article.value?.description && htmlToText(article.value.description),
      })

      doSetBreadcrumbs()
      setBreadcrumbsSchemaScript(breadcrumbs.value!)
    })

    onActivated(() => {
      doSetBreadcrumbs()
    })

    useMeta(() => htmlMeta.value)
    useMeta(() => {
      return breadcrumbsSchemaScript.value
        ? {
            script: [breadcrumbsSchemaScript.value],
          }
        : {}
    })

    const useBlocks = computed(() => article.value?.useBlocks)

    const pageBanner = computed(() => {
      return article.value?.images?.[0]?.src ?? brand.value?.img
    })

    const pageAbout = computed(() => {
      return article.value?.summary ?? brand.value?.description
    })

    return {
      brandName,
      brandUrl,

      useBlocks,
      pageBanner,
      pageAbout,
      ...useProductBrandData,
    }
  },

  head: {},
})
